import React from "react";

interface TrashIconProps {
  className?: string;
  onClick?: () => void;
}

export const TrashIcon = ({ className, onClick }: TrashIconProps) => (
  <svg
    className={className}
    onClick={onClick}
    width="21"
    height="21"
    viewBox="0 0 21 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.875 20.25C13.625 20.25 13.5 20.125 13.5 19.875V7.125C13.5 6.875 13.625 6.75 13.875 6.75H14.625C14.875 6.75 15 6.875 15 7.125V19.875C15 20.125 14.875 20.25 14.625 20.25H13.875ZM6.375 20.25C6.125 20.25 6 20.125 6 19.875V7.125C6 6.875 6.125 6.75 6.375 6.75H7.125C7.375 6.75 7.5 6.875 7.5 7.125V19.875C7.5 20.125 7.375 20.25 7.125 20.25H6.375ZM20.625 3C20.875 3 21 3.125 21 3.375V4.125C21 4.375 20.875 4.5 20.625 4.5H19.5V21.75C19.5 22.375 19.2812 22.9062 18.8438 23.3438C18.4062 23.7812 17.875 24 17.25 24H3.75C3.125 24 2.59375 23.7812 2.15625 23.3438C1.71875 22.9062 1.5 22.375 1.5 21.75V4.5H0.375C0.125 4.5 0 4.375 0 4.125V3.375C0 3.125 0.125 3 0.375 3H5.25L6.84375 0.890625C7.03125 0.640625 7.29688 0.4375 7.64062 0.28125C7.98438 0.09375 8.3125 0 8.625 0H12.375C12.6875 0 13.0156 0.09375 13.3594 0.28125C13.7031 0.4375 13.9688 0.640625 14.1562 0.890625L15.75 3H20.625ZM8.01562 1.78125L7.125 3H13.875L12.9844 1.78125C12.8281 1.59375 12.625 1.5 12.375 1.5H8.625C8.375 1.5 8.17188 1.59375 8.01562 1.78125ZM18 21.75V4.5H3V21.75C3 21.9688 3.0625 22.1406 3.1875 22.2656C3.34375 22.4219 3.53125 22.5 3.75 22.5H17.25C17.4688 22.5 17.6406 22.4219 17.7656 22.2656C17.9219 22.1406 18 21.9688 18 21.75ZM10.125 20.25C9.875 20.25 9.75 20.125 9.75 19.875V7.125C9.75 6.875 9.875 6.75 10.125 6.75H10.875C11.125 6.75 11.25 6.875 11.25 7.125V19.875C11.25 20.125 11.125 20.25 10.875 20.25H10.125Z"
      fill="black"
    />
  </svg>
);

TrashIcon.defaultProps = {
  className: "",
  onClick: undefined,
};
